import React, { Component } from 'react';

class Error extends Component {

  constructor(props) {
    super(props);
    this.state = {
      fadeOut: false
    }
  }

  componentWillMount() {
    this.setState({fadeOut: false})
    setTimeout(()=>{
      //fadeOut
      this.setState({fadeOut: true})
    }, 3500)
  }

  render(){
    const { text } = this.props;
    return (
      <div className={this.state.fadeOut ? "dm-error-overlay center-flex flex-item animated fadeOutDown" : "dm-error-overlay center-flex flex-item animated fadeInUp"}>
          {text}
      </div>
    );
  }
};

export { Error };



// WEBPACK FOOTER //
// ./src/components/common/Error.js